<template>
    <div>
         <div class="section section_two">
            <div class="main_content">
                <div class="container">
                    <div class="upperSection">
                        <div class="heading_section">
                            <h2  data-aos="fade-up">{{this.sustainability.title}}</h2> 
                        </div>
                        <div class="smallpara">
                            <p  data-aos="fade-up">
                                {{this.sustainability.richText}} 
                            </p>
                        </div>
                    </div>
                </div>
                <div class="container">
                        <div class="bottom-wrapper">
                            <div class="bottom-txt">
                                <div v-html="this.sustainability.richText2"  data-aos="fade-up"></div> 
                            </div>
                            <!-- <div class="scroll_icon">
                                <div class="scroll_svg_section p-relative"  >
                                    <a href="#slider-scroll" class="abs-link"></a>
                                    <div class="scroll-text"  > 
                                        Scroll To explore
                                    </div>
                                    <div class="scroll-svg" >
                                        <svg xmlns="http://www.w3.org/2000/svg" width="43" height="43" viewBox="0 0 43 43">
                                            <use xlink:href="#circle-arrow-down"></use>
                                        </svg>
                                    </div>
                                </div>
                            </div> -->
                        </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
const sustainability = [];
export default {
    name:"sustainability",
    props:{
        sustainability: Object
    },

     methods:{
        ScrollDown() {
            var inneerH = window.innerHeight
            document.body.scrollTop = inneerH;
            document.documentElement.scrollTop = inneerH;

        }
    }
}
</script>

<style lang="scss" scoped>
    .section_two{
        // @include Background('../../assets/images/corporate-sustainability/bg2.png');
        height:100vh;
        position: relative;
        &:after  {
            content: '';
            position: absolute;
            
            @include Background('../../assets/images/corporate-sustainability/bg2.png');
            width: 100%;
            height: 100%;
            top: 0;
            left: 0;
            z-index: -2;
        }
        .heading_section{
            padding-top:rem(60px);
        }
        h2{
            @include Heading(left)
        }
        .upperSection{
            max-width: 800px;
            // margin-left: auto;
            height: calc(100vh - 170px);
            position: relative;
            @media screen and (max-width:1199px){
                height: unset;
                max-width:100%;
                margin-bottom: rem(40px);
            }
            @media screen and (max-width:500px) {
                height: unset;
                
            }
        }
        @media screen and (max-width:1199px){
            .bottom-wrapper{
                flex-direction: column;
                align-items: center;
                justify-content: center;
                
                .bottom-txt{
                    margin-bottom:rem(25px);
                    text-align:center;
                }
                .scroll_icon{
                    position:static;
                    text-align: center;
                    transform: none;
                }
            }
        }
        @media screen and (max-width:991px){
            height:auto;
        }
    }
    // arabic
    [lang="ar"] {
        .section_two{
            &:after  {
                 -webkit-transform: scaleX(-1);
                transform: scaleX(-1);
                right: 0;
                left: auto;
            }
        }
        .section_two{
            h2{
                @include Heading(right)
            }
        }
    }
</style>